export default __webpack_public_path__ + "static/media/147.322e227f.gif";